import { gql } from 'apollo-angular';

export const companyDataFragment = gql`
fragment companyData on Company {
  video {
    public_id
    aspect_ratio
  }
  foundationYear
  employees
  turnover
  tonsPerYear
  prodPerYear
  certifications
}
`;
